import { render, staticRenderFns } from "./modalEnd.vue?vue&type=template&id=490f3b4a&scoped=true"
import script from "./modalEnd.vue?vue&type=script&lang=js"
export * from "./modalEnd.vue?vue&type=script&lang=js"
import style0 from "./modalEnd.vue?vue&type=style&index=0&id=490f3b4a&prod&lang=css"
import style1 from "./modalEnd.vue?vue&type=style&index=1&id=490f3b4a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f3b4a",
  null
  
)

export default component.exports